import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import { paginationData } from "../../utilities/functions";
import { fetchApi } from "../fetchApi";

const getDomain = (search) => {
  const domain = [
    ["company_id", "!=", false],
    ["type", "!=", "subscription"],
  ];
  const { query, type } = search;
  if (query) {
    domain.push(["name", "ilike", query]);
  }
  if (type) {
    domain.push(JSON.parse(type));
  }
  return domain;
};

export async function productSearchRead({
  context,
  company_id,
  pagination = { limit: PAGINATION_DEFAULT_LIMIT, offset: 0 },

  search = { query: "", type: "" },
  sort = { type: "", dir: "asc" },
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      model: "product.template",
      domain: getDomain(search),
      fields: [
        "product_variant_count",
        "sale_ok",
        "currency_id",
        "cost_currency_id",
        "website_sequence",
        "name",
        "default_code",
        "website_id",
        "is_published",
        "responsible_id",
        "barcode",
        "company_id",
        "list_price",
        "standard_price",
        "categ_id",
        "type",
        "show_on_hand_qty_status_button",
        "qty_available",
        "virtual_available",
        "uom_id",
        "active",
        "activity_exception_decoration",
        "activity_exception_icon",
        "image_1920",
      ],
      ...paginationData(pagination),
      sort: sort?.type ? `${sort?.type} ${sort?.dir}` : "", //   direction in the sorting parameter
      context: {
        lang: context.lang,
        tz: context.tz,
        uid: context.uid,
        allowed_company_ids: [company_id],
        default_type: "opportunity",
        search_default_assigned_to_me: 1,
        bin_size: true,
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({ requestOptions, endpoint: "/web/dataset/search_read" });
}
